import 'github-markdown-css';
import './sass/main.scss';
import './amplify.ts';
import './components';
import 'leaflet/dist/leaflet.css';
import 'vuetify/dist/vuetify.min.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import VueQrcode from 'qrcode.vue';
import VueMarkdown from 'vue-markdown';
import VueCompositionAPI from '@vue/composition-api';
import VueSocialSharing from 'vue-social-sharing';
import Main from './main.vue';
import i18n from './i18n';
import store from './store';
import router from './router';
import { setting } from './storage';
Vue.use(Vuetify);
Vue.use(VueSocialSharing);
Vue.use(VueCompositionAPI);
Vue.component('vue-qrcode', VueQrcode);
Vue.component('vue-markdown', VueMarkdown);
Vue.config.productionTip = false;
let vuetify = new Vuetify({
    icons: {
        iconfont: 'mdi'
    },
    theme: {
        dark: setting.dark
    }
});
new Vue({
    i18n,
    store,
    router,
    vuetify,
    render: h => h(Main)
}).$mount('#app');
document.getElementById('main-loading').style.display = 'none';
